import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationCheckFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.713 8.976L11.68 13.011C11.54 13.151 11.349 13.23 11.15 13.23C10.951 13.23 10.76 13.151 10.619 13.01L8.662 11.05C8.37 10.757 8.37 10.282 8.663 9.989C8.957 9.697 9.431 9.697 9.724 9.99L11.151 11.419L14.652 7.915C14.945 7.622 15.42 7.622 15.713 7.915C16.006 8.208 16.006 8.683 15.713 8.976ZM12 2.5C7.575 2.5 3.974 6.101 3.974 10.527C3.974 16.163 10.566 21.5 12 21.5C13.435 21.5 20.026 16.163 20.026 10.527C20.026 6.101 16.426 2.5 12 2.5Z",
		fill: "currentColor"
	})
});
export default SvgLocationCheckFill;
